var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDekkaYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ri:youtube-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.677 11.6582C32.5504 11.1615 32.1904 10.7865 31.7787 10.6715C31.0487 10.4665 27.5004 9.99984 20.0004 9.99984C12.5004 9.99984 8.9537 10.4665 8.2187 10.6715C7.81203 10.7848 7.45203 11.1598 7.3237 11.6582C7.14203 12.3648 6.66703 15.3248 6.66703 19.9998C6.66703 24.6732 7.14203 27.6332 7.3237 28.3432C7.45036 28.8382 7.81036 29.2132 8.22036 29.3265C8.9537 29.5332 12.4987 29.9998 19.9987 29.9998C27.4987 29.9998 31.047 29.5332 31.7804 29.3282C32.187 29.2148 32.547 28.8398 32.6754 28.3415C32.8587 27.6348 33.332 24.6665 33.332 19.9998C33.332 15.3332 32.8587 12.3665 32.677 11.6582ZM35.9054 10.8298C36.667 13.7998 36.667 19.9998 36.667 19.9998C36.667 19.9998 36.667 26.1998 35.9054 29.1698C35.482 30.8115 34.2437 32.1032 32.6754 32.5398C29.827 33.3332 19.9987 33.3332 19.9987 33.3332C19.9987 33.3332 10.177 33.3332 7.3237 32.5398C5.7487 32.0965 4.51203 30.8065 4.0937 29.1698C3.33203 26.1998 3.33203 19.9998 3.33203 19.9998C3.33203 19.9998 3.33203 13.7998 4.0937 10.8298C4.51703 9.18817 5.75536 7.8965 7.3237 7.45984C10.1787 6.6665 20.0004 6.6665 20.0004 6.6665C20.0004 6.6665 29.827 6.6665 32.6754 7.45984C34.2487 7.90317 35.487 9.19317 35.9054 10.8298ZM16.667 25.8332V14.1665L26.667 19.9998L16.667 25.8332Z",
    fill: "#ECF6FB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDekkaYoutube);
export default __webpack_public_path__ + "static/media/dekka-youtube.41bb6bbc8f988a322972f68cdb71ae73.svg";
export { ForwardRef as ReactComponent };